import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss']
})
export class UserAvatarComponent implements OnInit {
  @Input() avatarUrl: string = "";
  @Input() userFullName: string = "";
  @Input() cursorPointer: boolean = false;
  @Input() width: number = 30;
  @Input() height: number = 30;
  @Input() fontSizeInPx: number = 12;
  @Input() isAvatar: boolean = false;

  ngOnInit() {
    this.isAvatar = this.isAvatar !== undefined ? this.isAvatar : this.avatarUrl.includes(".png");
  }

  onImgError() {
    this.isAvatar = false;
  }
}
